import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled from 'styled-components'

import { decodeHtml } from '@nx/decode-html'
import { FireButton, FireButtonProps } from '@nx/fire/button'
import { Body } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import translate from './WonLot.translate.json'

const { text } = getTranslate(translate)

export const WonLot = memo(
  ({
    soldPrice,
    isPremium,
    invoiceId,
    currencySymbol,
    variant = 'ghost',
    ...otherProps
  }: WonLotProps) => {
    return (
      <>
        <StyledWonLotLabel $level="M" {...otherProps}>
          {isPremium
            ? text('premium', {
                price: buildPriceString({
                  currencySymbol: decodeHtml(currencySymbol),
                  lowPrice: soldPrice,
                }),
              })
            : text('price', {
                price: buildPriceString({
                  currencySymbol: decodeHtml(currencySymbol),
                  lowPrice: soldPrice,
                }),
              })}
        </StyledWonLotLabel>

        <StyledInvoiceButton
          variant={variant}
          disabled={!invoiceId}
          href={
            invoiceId
              ? `/mybonhams/invoices/pay/?invoiceIds=${invoiceId}`
              : undefined
          }
          {...otherProps}
        >
          {invoiceId ? text('checkout') : text('checkoutSoon')}
        </StyledInvoiceButton>
      </>
    )
  },
  isEqual
)

export const StyledWonLotLabel = styled(Body)`
  margin-bottom: 10px;
  padding-bottom: 10px;
`

export const StyledInvoiceButton = styled(FireButton)`
  color: ${({ theme }) => theme.colours.primary.primary};
`

interface WonLotProps {
  currencySymbol: string
  invoiceId?: string
  soldPrice: number
  isPremium: boolean
  variant?: FireButtonProps['variant']
}
